module.exports = __webpack_public_path__ + "static/media/CopyKeyFrameDisable.b74383e7.svg";